import cn from 'clsx';
import { FC } from 'react';

import { TextButtonModel } from '../../../types';
import TextButton from '../../Button/Text';

import s from './SubHeaderTitle.module.scss';

export interface SubHeaderTitleProps {
  title: string;
  count?: string;
  border?: boolean;
  className?: string;
  button?: TextButtonModel;
}

const SubHeaderTitle: FC<React.PropsWithChildren<React.PropsWithChildren<SubHeaderTitleProps>>> = ({ title, count, border = false, className, button }) => {
  return (
    <div className={className}>
      <div className={cn(s.wrap, { [s.border as string]: border })}>
        <div className={s.innerWrap}>
          <p className={s.title}>{title}</p>
          {count && <span className={s.count}>{count}</span>}
        </div>

        {button && (
          <TextButton state={button.state} size="small" icon={button.icon} onClick={button.onClick}>
            {button.label}
          </TextButton>
        )}
      </div>
    </div>
  );
};

export default SubHeaderTitle;
